import { TimeseriesGraphConfig } from '@shared/components/timeseries-graph/timeseries-graph-config';

export const defaultTimeseriesGraphConfig: TimeseriesGraphConfig = {
  defaultVisualization: 'bar',
  availableVisualizations: ['bar', 'line'],
  dateRange: true,
  showLegend: true,
  reset: true,
}
